<span class="star-rating">
    <span class="star" *ngFor="let star of stars" [class.filled]="star <= currentRating">
      &#9733;
    </span>
</span>